export const MeetingPageUrl = process.env.REACT_APP_MEETING_BASE_URL
export const SymposiaPageUrl = `${process.env.REACT_APP_MEETING_BASE_URL}/event`
export const SymposiaProposalPageUrl = `${process.env.REACT_APP_MEETING_BASE_URL}/symposia-proposal`
export const SymposiaWorkshopPageUrl = `${process.env.REACT_APP_MEETING_BASE_URL}/symposia-workshop`
export const SearchKeywordPageUrl = `${process.env.REACT_APP_MEETING_BASE_URL}/search-keyword`
export const MyAgendadPageUrl = `${process.env.REACT_APP_MEETING_BASE_URL}/MyAgenda`
export const MyMeetingMaterialPageUrl = `${process.env.REACT_APP_MEETING_BASE_URL}/MyMeetingMaterial`
export const MySchedulePageUrl = `${process.env.REACT_APP_MEETING_BASE_URL}/MySchedule`

export default {
	MeetingPageUrl,
	SymposiaPageUrl,
	SymposiaProposalPageUrl,
	SymposiaWorkshopPageUrl,
	SearchKeywordPageUrl,
	MyAgendadPageUrl,
	MyMeetingMaterialPageUrl,
	MySchedulePageUrl
}